import React from 'react';
import PropTypes from 'prop-types';
import addContext from './addContext';

export default function addD2Context(Component) {
    return addContext(Component, { d2: PropTypes.object });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2-ui/lib/component-helpers/addD2Context.js
// module id = 126
// module chunks = 0